<section id="ngx-datatable-filter">
	<div class="row">
		<div class="col-12">
			<div class="card">
				<div class="card-content">
					<div class="card-body">
						<!-- ngx-datatable-filter -->
						<fieldset class="form-group">
							<div class="row align-items-end mt-0 pagination-body">

								<div class="col-12 col-sm-12 col-md-3 col-lg-3 mb-2"></div>
								<div class="col-12 col-sm-12 col-md-9 col-lg-9 mt-2 mb-1">
									<div class="row-flex">
										<div class="col-flex-2 mb-1 position-relative">
											<input id="ngx-filter-ref"
												class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
												type="text" (keydown.enter)="getFilterClientPipeline(name.value)"
												placeholder="Search by Client Name/Email/Phone" #name />
											<button class="btn search-btn glow position-absolute"
												(click)="getFilterClientPipeline(name.value)">
												<i class="ft-search text-white cursor-pointer"></i>
											</button>
										</div>
										<div class="col-flex-2 mb-1">
											<button class="btn btn-primary btn-block users-list-clear glow mb-0"
												(click)="resetFilter()">
												Reset
												<i class="ft-filter text-white cursor-pointer"></i>
											</button>
										</div>
										<div class="col-flex-2 mb-1"
											*ngIf="user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
											<button type="button"
												class="btn btn-primary btn-block users-list-clear glow mb-0"
												(click)="openMatchModal(matchModal)" placement="top"
												ngbTooltip="Matching CP">
												Match With Client
											</button>
										</div>
										<div class="col-flex-2 mb-1"
											*ngIf="user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
											<button type="button"
												class="btn btn-primary btn-block users-list-clear glow mb-0"
												(click)="openImportModal(importModal)" placement="top"
												ngbTooltip="Import CSV">
												Import
											</button>
										</div>
										<div class="col-flex-2 mb-1"
											*ngIf="user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
											<button type="button"
												class="btn btn-success btn-block users-list-clear glow mb-0"
												(click)="openExportModal(exportModal)" placement="top"
												ngbTooltip="Export CSV">
												Export
											</button>
										</div>
										<div class="col-flex-2 mb-1"
											*ngIf="user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
											<button type="button"
												class="btn btn-primary btn-block users-list-clear glow mb-0"
												routerLink="/client-pipeline-add" placement="top" ngbTooltip="Add New">
												+
											</button>
										</div>

									</div>
								</div>
								<div class="col-12 col-sm-12 col-md-12 col-lg-12 pagination-body header-body mb-2">
									<ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force"
										[headerHeight]="40" [footerHeight]="40" rowHeight="auto" [limit]="limitRef"
										[rows]="rows" [externalPaging]="true" [count]="page.totalPages"
										[offset]="page.pageNumber" (page)="pageChangeData($event)">
									</ngx-datatable>
								</div>
								<div class="col-12">
									<button *ngIf="guideline_data" class="btn btn-outline-primary"
										(click)="openDynamicModal(guideline_data)">Client Pipelines Guideline</button>
								</div>
							</div>
						</fieldset>
						<ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force"
							[headerHeight]="50" [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows"
							[scrollbarH]="true" [columns]="columns" [externalPaging]="true" [count]="page.totalPages"
							[offset]="page.pageNumber" (page)="pageChangeData($event)">

							<ngx-datatable-column name="Client Name" prop="clientName">
								<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
									<div class="d-flex align-items-center">
										<div *ngIf="row.image">
											<img class="rounded-circle mr-1" [src]="imageUrl + row.image" height="32"
												width="32" alt="datatable-avatar" />
										</div>
										<div *ngIf="!row.image" class="avatar mr-1 ml-0 bg-primary">
											<div class="avatar-content">
												{{ row?.clientName |titlecase | shortName }}
											</div>
										</div>
										<!-- --------- card ------------------------------------ -->
										<div class="card-overlay-on-hover">
											<div class="card">
												<div class="card-content">
													<div class="card-img">
														<img *ngIf="row.image" class=" card-img-top img-fluid "
															[src]="imageUrl + row.image" alt="Card image cap">
														<div *ngIf="!row.image" class="avatarImg mr-1 ml-0 bg-primary">
															<div class="avatar-contentImg">{{ row?.clientName |
																shortName }}</div>
														</div>
													</div>
													<div class="card-body p-0">
														<h4>{{row?.clientName}}</h4>
														<p>{{row?.clientEmail}}</p>
														<p>{{row?.college?.name}}</p>
														<p>{{row?.clientPhone}}</p>
													</div>
												</div>
											</div>
										</div>
										<!-- ---------------------------------------------------------- -->
										<div class="cell-line-height">
											<a class="line-height-1 mb-0"
												[routerLink]="['/admin/client-pipeline-edit', row._id]"
												(click)="editUser(row._id)">{{ row?.clientName }}</a>
										</div>
									</div>
								</ng-template>
							</ngx-datatable-column>

							<ngx-datatable-column name="Client Email" prop="clientEmail">
								<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>{{
									row?.clientEmail }}</ng-template>
							</ngx-datatable-column>

							<ngx-datatable-column name="Client Phone" prop="clientPhone" [width]="50">
								<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>{{
									row?.clientPhone }}</ng-template>
							</ngx-datatable-column>


							<ngx-datatable-column name="Status" prop="status">
								<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
									{{ row?.status }}
								</ng-template>
							</ngx-datatable-column>

							<ngx-datatable-column name="Merged" prop="isMerged">
								<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
									{{ row?.isMerged ? 'Yes' : 'No' }}
								</ng-template>
							</ngx-datatable-column>



							<ngx-datatable-column name="Actions"
								*ngIf="user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<i mat-button [matMenuTriggerFor]="menu"
										class="ft-more-vertical text-primary cursor-pointer mr-2"></i>
									<mat-menu #menu="matMenu">
										<div class="action-btn">
											<i class="ft-check-circle text-success cursor-pointer"></i>
											<button mat-menu-item (click)="matchClientPipeline(row._id)">
												Match Client
											</button>
										</div>
										<div class="action-btn">
											<i class="ft-edit text-primary cursor-pointer"></i>
											<button mat-menu-item
												[routerLink]="['/admin/client-pipeline-edit', row._id]"
												(click)="editUser(row._id)">
												Edit
											</button>
										</div>
										<div class="action-btn" *ngIf="user_role.roles =='admin'">
											<i class="ft-trash-2 text-danger cursor-pointer"></i>
											<button mat-menu-item (click)="ConfirmColor(row._id)">
												Delete
											</button>
										</div>
									</mat-menu>
								</ng-template>
							</ngx-datatable-column>
						</ngx-datatable>

						<!-- ngx-datatable-filter -->
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<div class="d-flex justify-content-between align-items-center">
	<ngx-spinner></ngx-spinner>
</div>
<!--/ Filter Datatables -->

<!---------- Import CSV Popup ---------------->
<div>
	<ng-template #importModal let-modal>
		<div class="modal-header">
			<h4 class="modal-title">Import Client Pipeline CSV</h4>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<ng-template #columnInfoTooltip style="z-index: 99999999999; position: absolute; top: 0; left: 0;">
				<div style="text-align: left;">
					<strong>Required Excel/CSV column names (must match exactly):</strong><br>
					• clientName<br>
					• clientEmail<br>
					• clientPhone<br>
					• Interested in<br>
					• notes<br>
					• eventid<br>
					• status<br>
					• source<br>
					• Timeline<br>
					• programtags<br><br>
					<strong>Note:</strong> If any column name is misspelled, that field will not be imported.
				</div>
			</ng-template>
			<form>

				<div class="form-group">
					<label for="import_filename">Filename Label <span class="text-danger">*</span></label>
					<input type="text" class="form-control" id="import_filename"
						[(ngModel)]="import_model.import_filename" [ngModelOptions]="{ standalone: true }"
						placeholder="Filename label to stamp on every imported document" />
					<small class="form-text text-muted">Filename label to stamp on every imported document</small>
				</div>
				<div class="form-group">
					<label for="collage_id">College <span class="text-danger">*</span></label>
					<ng-select [items]="collegeList" bindLabel="name" bindValue="_id" placeholder="Select College"
						[(ngModel)]="import_model.collage_id" [ngModelOptions]="{ standalone: true }"
						[appendTo]="'body'"></ng-select>
					<small class="form-text text-muted">College to apply to every imported document</small>
				</div>
				<div class="form-group">
					<label for="file">File <span class="text-danger">*</span>
						<i class="ft-info text-info ml-1 cursor-pointer" placement="top"
							[ngbTooltip]="columnInfoTooltip" triggers="hover">
						</i>
					</label>
					<input type="file" class="form-control" id="file" (change)="onFileSelected($event)"
						accept=".csv,.xlsx,.xls" />
					<small class="form-text text-muted" *ngIf="!selectedFileName">CSV or Excel file</small>
					<small class="form-text text-success" *ngIf="selectedFileName">
						<i class="ft-file"></i> Selected: <strong>{{ selectedFileName }}</strong>
					</small>
				</div>
			</form>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
			<button type="button" class="btn btn-primary" (click)="submitImport()" [disabled]="!isImportFormValid()">
				Import
			</button>
		</div>
	</ng-template>
</div>

<!---------- Export CSV Popup ---------------->
<div>
	<ng-template #exportModal let-modal>
		<div class="modal-header">
			<h4 class="modal-title">Export Client Pipeline CSV</h4>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<form>
				<div class="form-group">
					<label for="export_status">Status</label>
					<ng-select [items]="statusList" bindLabel="name" bindValue="value"
						placeholder="Select Status (optional)" [(ngModel)]="export_model.status"
						[ngModelOptions]="{ standalone: true }" [appendTo]="'body'" [clearable]="true"></ng-select>
					<small class="form-text text-muted">Filter by status</small>
				</div>
				<div class="form-group">
					<label for="export_import_filename">Import Filename</label>
					<input type="text" class="form-control" id="export_import_filename"
						[(ngModel)]="export_model.import_filename" [ngModelOptions]="{ standalone: true }"
						placeholder="Filter by import filename (comma-separated for multiple)" />
					<small class="form-text text-muted">Filter by import filename. For multiple, pass comma-separated
						values</small>
				</div>
				<div class="row">
					<div class="col-md-6">
						<div class="form-group">
							<label for="export_start_date">Start Date</label>
							<input type="date" class="form-control" id="export_start_date"
								[(ngModel)]="export_model.start_date" [ngModelOptions]="{ standalone: true }" />
							<small class="form-text text-muted">Start date (inclusive) for created_at</small>
						</div>
					</div>
					<div class="col-md-6">
						<div class="form-group">
							<label for="export_end_date">End Date</label>
							<input type="date" class="form-control" id="export_end_date"
								[(ngModel)]="export_model.end_date" [ngModelOptions]="{ standalone: true }" />
							<small class="form-text text-muted">End date (inclusive) for created_at</small>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-6">
						<div class="form-group">
							<label for="export_month">Month</label>
							<input type="text" class="form-control" id="export_month" [(ngModel)]="export_model.month"
								[ngModelOptions]="{ standalone: true }" placeholder="e.g. 07 or July" />
							<small class="form-text text-muted">Filter by timelinetags.month</small>
						</div>
					</div>
					<div class="col-md-6">
						<div class="form-group">
							<label for="export_year">Year</label>
							<input type="text" class="form-control" id="export_year" [(ngModel)]="export_model.year"
								[ngModelOptions]="{ standalone: true }" placeholder="e.g. 2025" />
							<small class="form-text text-muted">Filter by timelinetags.year</small>
						</div>
					</div>
				</div>
			</form>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
			<button type="button" class="btn btn-success" (click)="submitExport()">
				Export
			</button>
		</div>
	</ng-template>
</div>

<!---------- Pipeline Stage Popup ---------------->
<div>
	<ng-template #myModalPipelineStage let-modal>
		<div class="modal-header">
			<h4 class="modal-title" *ngIf="selected_pipeline_stage">Pipeline Stage Update</h4>
			<h4 class="modal-title" *ngIf="!selected_pipeline_stage">Pipeline Stage Add</h4>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<form>
				<div class="form-group">
					<label>Pipeline Stage</label>
					<ng-select [items]="pipeline_stages" bindLabel="name" bindValue="_id"
						placeholder="Select Pipeline Stage" [(ngModel)]="selected_pipeline_stage"
						[ngModelOptions]="{ standalone: true }" [appendTo]="'body'" [virtualScroll]="true"
						[clearSearchOnAdd]="true">
					</ng-select>
				</div>
			</form>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
			<button type="button" class="btn btn-primary" (click)="pipelineStageUpdate()">Submit</button>
		</div>
	</ng-template>
</div>

<div>
	<ng-template #matchModal let-modal>
  <div class="modal-header w-70">
    <h4 class="modal-title">Match Client Pipeline with Clients</h4>
    <button type="button" class="close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label for="collegeSelect">Select College (Optional)</label>
      <select class="form-control" id="collegeSelect" [(ngModel)]="selectedCollegeId">
        <option value="">None</option>
        <option *ngFor="let college of collegeList" [value]="college._id">
          {{college.name}}
        </option>
      </select>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="matchClients()" [disabled]="isMatching">
      <span *ngIf="!isMatching">
        {{ selectedCollegeId ? 'Match with Selected College' : 'Match All Clients' }}
      </span>
      <span *ngIf="isMatching">
        <i class="fa fa-spinner fa-spin"></i> Matching...
      </span>
    </button>
  </div>
</ng-template>

</div>
